import { useEffect } from 'react';

import { idStore } from '@pharmaplan/common/helpers/ServiceHandler';
import { adminBookingDetails } from '@pharmaplan/common';

import { FormikProps } from 'formik';
import { useAppSelector } from '../../useAppSelector';
import { hasAction } from '../../../components/Reports/helpers';

const useExpressBookingDisabled = (formik:FormikProps<any>, formikPharmacistId: string, isBooking:boolean) => {
  const bookedDetails = useAppSelector(adminBookingDetails);

  const userId = bookedDetails[idStore.id as keyof typeof bookedDetails];
  const { startDate } = bookedDetails;
  const isPastBooking = isBooking && !!startDate && !hasAction(startDate);

  useEffect(() => {
    // Editing a past booking doesn't notify the professional or the pharmacy by default.
    const shouldSendEmail = userId !== formikPharmacistId && !isPastBooking;
    if (isBooking) {
      formik.setFieldValue('sendEmailToPharmacist', shouldSendEmail);
      formik.setFieldValue('sendEmailToPharmacy', shouldSendEmail);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formikPharmacistId, userId, isPastBooking]);

  return { isPastBooking };
};

export default useExpressBookingDisabled;
